import React, { useCallback } from "react"
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from "./style.module.scss"
import Cache from "../../../../../utils/cache"
import { fetchStockOutSubscribe,fetchStockOutUnSubscribe } from "../../../../../api"
import { BlackMask } from "../../../../components/mask"
import { useState } from "react"
import _ from "lodash"
import { useEffect } from "react"

import { BigButton } from "../../../../components/button"
import AddToWish from "../addtowish"
import { FormattedMessage, useIntl } from "react-intl"
import { Iconfont } from "../../../../components/icon/iconfont"
import { TOGGLE_UI_LOGIN } from '../../../../../store/actions/ui'
import { action_fetch_bottom_banner } from '../../../../../store/actions/pages/product'
import { useDispatch, useSelector } from "react-redux"
import { useMemo } from "react"
import { isFlashSales, unitPrice } from "../../../../../utils/product"
import { getOriginalSize } from "../../../../utils/sensor"
import NormalSwiper from "../../../../components/swiper/autowidth/index"
import BottomBannerTip from "../bottom-banner"
import { useQuery } from "../../../../hooks/common"
import { withCartIcon } from "../../../listing/components/cart/cart-icon"
import BuyBtn from "../buy-btn";

const CartIcon = withCartIcon(props =>{
    const { onCart, loading } = props;

    return <BigButton 
        className={`${classes.AddToCart}`} 
        onClick={onCart} 
        loading={loading}
    >
        <FormattedMessage id="add_to_cart" defaultMessage="Add to Cart" />
    </BigButton>
});

const StockOutModal = props =>{
    useStyles(classes);
    return (
        <React.Fragment>
            <div className={classes.stockOutModalContainer}>
                <div className={classes.Hd}>
                    <span className="iconfont" onClick={props.onClose}>&#xe7c9;</span>
                </div>
                <div className={classes.Bd}>
                    <p><FormattedMessage id="if_the_item_comes_back" defaultMessage="If the item comes back into stock within 30 days, we will send you an email." /></p>
                    <button onClick={props.onClose}>OK</button>
                </div>
            </div>

            <BlackMask onClick={props.onClose} />
        </React.Fragment>
    )
}

const RollingDiscount = props =>{
    const { rollingMessages } = props;

    return <div className={classes.RollingDiscountContainer}>
        <NormalSwiper 
            options={{
                direction: 'vertical',
                loop: rollingMessages?.length > 1,
                autoplay: rollingMessages?.length > 1 ? {
                    disableOnInteraction:false,
                    delay: 5000
                } : false
            }} 
            items={rollingMessages} 
            className={classes.RollingDiscount} 
            render={(message, index) =>(
                <span className={classes.DiscountLink}>
                    {
                        message?.iconImage && <img src={message.iconImage} alt="IconImage" />
                    }
                    <span dangerouslySetInnerHTML={{ __html: message?.msg }}></span>
                </span>
            )}
        />
    </div>
}

export default props =>{
    useStyles(classes);
    const { 
        isDetail,
        onAddCart,
        selectedProduct,
        selectedVariant,
        loading,
        isBeautyNotAddCart,
        bottomBanner, 
        rollingMessages, 
        babiesLookShow,
        estimatedPrice,
        showBtnEstimatedPrice,
        onQuickBuy
    } = props

    const dispatch = useDispatch()
    const global = useSelector(state => state.global)
    const [showBanner, setShowBanner] = useState(false)
    const [showModal,setShowModal] = useState(false);
    const [isNotifyMe,setIsNotifyMe] = useState();
    
    const query = useQuery();

    const findSimilarEvent = () =>{
        if(window.GeekoSensors){
            window.GeekoSensors.Track('ELClick', {
                clicks:"findsimilar",
                variantId:selectedVariant?.id,
                size: getOriginalSize(selectedVariant?.size),
                color:selectedVariant?.color,
                product_sku:selectedVariant?.sku
            })
        }

        window.location.href = `/similar/${selectedProduct.id}.html`;
    }

    const getStockOutProduct = (variantId) =>{
        let stockOutItem = Cache.get("shortagenotification");
        return stockOutItem?.findIndex(item =>item === variantId);
    }

    useEffect(() => {
        const nitifyMe = getStockOutProduct(selectedVariant?.id) >= 0
        setIsNotifyMe(nitifyMe)
    }, [])

    useEffect(() =>{
        setIsNotifyMe(getStockOutProduct(selectedVariant?.id) >= 0);
    },[selectedVariant?.id]);

    useEffect(() => {
        if(isDetail){
            // if(query.utm_source && query.utm_source != "traffic"){
            //     Cache.remove('has-utmsource');
            // }

            const shouldShow = !!!Cache.get('product-bottom-banner');
            const canShowBottom = !!Cache.get('has-utmsource')
            // if((query?.utm_source == "traffic" || canShowBottom)){
            //     setShowBanner(false)
            // }else{
                // if(isDetail){
                    if(shouldShow){
                        setShowBanner(true);
        
                        if(window.GeekoSensors){
                            window.GeekoSensors.Track('ELExpose', {
                                clicks:"bottom-coupon",
                            })
                        }
                    }
                // }
            // } 
        }
    }, [])


    useEffect(() => {
    }, []);

    const notifyMeEnevt = async (variantId) =>{
        let stockOutItem = Cache.get("shortagenotification");
        stockOutItem = _.cloneDeep(stockOutItem);
        let data,flag;
        if(stockOutItem){
            let index = getStockOutProduct(variantId);
            if(isNotifyMe){
                data = await fetchStockOutUnSubscribe(variantId);
                if(data){
                    stockOutItem.splice(index,1);
                    flag = false;
                    setIsNotifyMe(false);
                }
            }else{
                data = await fetchStockOutSubscribe(variantId);
                if(data){
                    stockOutItem.push(variantId);
                    flag = true;
                    setIsNotifyMe(true);
                }
            }
        }else{
            data = await fetchStockOutSubscribe(variantId);
            if(data){
                stockOutItem = [variantId];
                flag = true;
                setIsNotifyMe(true);
            }
            
        }
        if(data){
            await Cache.set("shortagenotification",stockOutItem);
            setShowModal(flag);

            if(window.GeekoSensors){
				window.GeekoSensors.Track('ELClick', {
					clicks:"notifyme",
					variantId:selectedVariant?.id,
					size: getOriginalSize(selectedVariant?.size),
					color:selectedVariant.color,
					product_sku:selectedVariant?.sku
				})
			}
        }
    }

    const isEnabled = v => {
		if (!v) return true
		return v.status === '1' && v.inventory > 0 || (v.domesticDelivery && v.domesticDelivery.enabled && v.domesticDelivery.inventory > 0)
	}

    const isDisabled = !isEnabled(selectedVariant) || (isFlashSales(selectedProduct) && selectedProduct?.promotion?.salesQty >= selectedProduct?.promotion?.totalQty);

    const disposeHeight = useMemo(() =>{
        let height = 0;
        if(bottomBanner?.title){
            height += 40;
        }

        if(isDisabled){
            height += 28;
        }

        if(rollingMessages?.length > 0){
            height += 30;
        }

        return height;
    }, [bottomBanner?.title, rollingMessages, isDisabled]);

    const handleCloseBanner = useCallback(e => {
        setShowBanner(false)
        Cache.set('product-bottom-banner', 1)
    }, [])

    const handleBottomClick = useCallback(b => {

        if(window.GeekoSensors){
            window.GeekoSensors.Track('ELClick', {
                clicks:"bottom-coupon",
            })
        }



        if(b.isLogin){
            dispatch({
                type: TOGGLE_UI_LOGIN,
                payload: {
                    showLogin:true,
                    eventType:"弹窗",
                    callBack: function(){
                       return dispatch(action_fetch_bottom_banner())
                    }
                }
            })
        }else if(b.href){
            window.location.href = b.href
        }
    }, [])

    return (
        <React.Fragment>

            <div className={`${classes.ProductAddtocartContainer} ${!isDetail ? classes.ModalCartContainer : ""}`}>
                {
                    isDetail && <React.Fragment>
                        {/* {
                            !showBanner ? <React.Fragment> */}
                                <BottomBannerTip />
                            {/* </React.Fragment> : <React.Fragment>
                                {
                                    !isDisabled && bottomBanner && bottomBanner?.title && !global.user?.id && <div className={classes.BottomBanner} style={{
                                        color: bottomBanner?.theme?.color,
                                        background: bottomBanner?.theme?.background
                                    }}>
                                        <Iconfont className={classes.Close} onClick={handleCloseBanner}>&#xe69a;</Iconfont>
                                        <div className={classes.Content}>
                                            <div className={classes.Title}>{bottomBanner?.title}</div>
                                            <div className={classes.Description}>{global.user?.id && bottomBanner?.logedDescription ? bottomBanner?.logedDescription: bottomBanner?.description}</div>
                                        </div>
                                        {
                                            bottomBanner?.button && ( !bottomBanner?.button.isLogin || (bottomBanner?.button.isLogin && !global.user?.id)) && <button onClick={() => handleBottomClick(bottomBanner?.button)} className={classes.Button} style={{color: bottomBanner?.button?.color ,backgroundColor: bottomBanner?.button?.backgroundColor}}>{bottomBanner?.button?.text}</button>
                                        }
                                    </div>
                                }
                            </React.Fragment>
                        } */}
                    </React.Fragment>
                }

                {
                    isDisabled && <div className={classes.StockOutMessage}>
                        {
                            isNotifyMe ? (<FormattedMessage id="you_haveArrival_reminder" defaultMessage="You have already subscribed to the arrival reminder" />) : (<FormattedMessage id="sold_out_notification" defaultMessage="The item is sold out, click notify me for restock notification" />)
                        }
                    </div>
                }

                <div className={classes.ProductAddtocartItem}>
                    {/*<AddToWish productId={selectedProduct?.id} className={classes.AddToWish} />*/}
                    {
                        babiesLookShow ? <React.Fragment>
                            <CartIcon 
                                productId={selectedProduct?.id} 
                                sensors={{
                                    resourcepage_title: 'product',
                                    resource_type: '28',
                                    resource_content: 'InfluencerOutfit',
                                    resource_position: '1'
                                }} 
                            />
                        </React.Fragment> : <React.Fragment>
                            {
                                isDisabled ? (
                                    <div className={classes.StockOutContainer}>
                                        <span className={classes.FindSimilar} onClick={findSimilarEvent}><FormattedMessage id="find_simlar" defaultMessage="Find Simlar" /></span>
                                        <span className={classes.NotifyMe} onClick={() =>notifyMeEnevt(selectedVariant?.id)}>
                                            {
                                                isNotifyMe ? (<FormattedMessage id="un_subscribe" defaultMessage="UNSUBSCRIBE" />) : (<FormattedMessage id="notify_me" defaultMessage="Notify Me" />)
                                            }
                                        </span>
                                    </div>
                                ) : (
                                    <BigButton 
                                        className={`${classes.AddToCart} ${isBeautyNotAddCart && classes.NotAddTocart}`} 
                                        onClick={onAddCart} 
                                        disabled={isDisabled}
                                        loading={loading}
                                    >
                                        <FormattedMessage id="add_to_cart" defaultMessage="Add to Cart" />
                                        {/* {
                                            showBtnEstimatedPrice && estimatedPrice &&
                                            <p className={classes.ButtonEstimated}><FormattedMessage id="estimated" defaultMessage="Estimated" />{" "+unitPrice(estimatedPrice)}</p>
                                        } */}
                                    </BigButton>
                                )
                            }
                            {isDetail&&<BuyBtn quickBuyBtnHandle={onQuickBuy}/>}
                        </React.Fragment>
                    }
                    
                </div>

                {
                    isDetail && rollingMessages?.length > 0 && <RollingDiscount rollingMessages={rollingMessages} />
                }

                {
                    showModal && <StockOutModal onClose={() =>setShowModal(false)} />
                }
            </div>

            <div style={{ height: disposeHeight }}></div>
        </React.Fragment>
    )
}